<template>
  <div
    class="flex flex-col gap-3 mb-6 sm:flex-row sm:items-center sm:justify-between"
  >
    <slot />
  </div>
</template>
